export default __webpack_public_path__ + "static/media/star.fd8cae9c.svg";